"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
// import {useLocation} from 'react-router-dom';
// import {AppContext, User} from '../../shared/context';
// function renderSignIn(user: User | undefined, pathname: string) {
//     if (user) {
//         return (
//             <div className="header__top-content header__top-content_right">
//                 <a className="header__link" href="/auth/logout">
//                     Sign out
//                 </a>
//             </div>
//         );
//     }
//     return (
//         <div className="header__top-content header__top-content_right">
//             <a className="header__link" href={`/auth/google?returnPath=${encodeURIComponent(pathname)}`}>
//                 Sign in
//             </a>
//         </div>
//     );
// }
function renderNavigation() {
    return (react_1.default.createElement("div", { className: "header__navigation-content" },
        react_1.default.createElement("span", { className: "header__navigation-element" },
            react_1.default.createElement("a", { href: "/random", className: "header__link" }, "Random page")),
        react_1.default.createElement("span", { className: "header__navigation-element" },
            react_1.default.createElement("a", { href: "/scp-list", className: "header__link" }, "Series I")),
        react_1.default.createElement("span", { className: "header__navigation-element" },
            react_1.default.createElement("a", { href: "/scp-list-2", className: "header__link" }, "Series II")),
        react_1.default.createElement("span", { className: "header__navigation-element" },
            react_1.default.createElement("a", { href: "/scp-list-3", className: "header__link" }, "Series III")),
        react_1.default.createElement("span", { className: "header__navigation-element" },
            react_1.default.createElement("a", { href: "/scp-list-4", className: "header__link" }, "Series IV")),
        react_1.default.createElement("span", { className: "header__navigation-element" },
            react_1.default.createElement("a", { href: "/scp-list-5", className: "header__link" }, "Series V")),
        react_1.default.createElement("span", { className: "header__navigation-element" },
            react_1.default.createElement("a", { href: "/scp-list-6", className: "header__link" }, "Series V")),
        react_1.default.createElement("span", { className: "header__navigation-element" },
            react_1.default.createElement("a", { href: "/scp-list-7", className: "header__link" }, "Series V")),
        react_1.default.createElement("span", { className: "header__navigation-element" },
            react_1.default.createElement("a", { href: "/scp-list-ru", className: "header__link" }, "Series RU")),
        react_1.default.createElement("span", { className: "header__navigation-element" },
            react_1.default.createElement("a", { href: "/stories", className: "header__link" }, "Stories")),
        react_1.default.createElement("span", { className: "header__navigation-element" },
            react_1.default.createElement("a", { href: "/canon-hub", className: "header__link" }, "Canons"))));
}
const Header = () => {
    // const ctx = useContext(AppContext);
    // const location = useLocation();
    return (react_1.default.createElement("header", { className: "header" },
        react_1.default.createElement("div", { className: "header__container" },
            react_1.default.createElement("div", { className: "header__top-content" },
                react_1.default.createElement("a", { href: "/", className: "header__link" }, "SCP Foundation"))),
        react_1.default.createElement("div", { className: "header__navigation" }, renderNavigation())));
};
exports.default = Header;
//# sourceMappingURL=Header.js.map